"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterTypeOptions = void 0;
const graph_1 = require("@blockprotocol/graph");
const react_1 = require("react");
/**
 * Return a list of types options, minus any exclusions, returning only the latest version of each
 * @param typeOptions the list of types to filter
 * @param typesToExclude the types to exclude from the list (all versions will be excluded)
 */
const useFilterTypeOptions = ({ typeOptions, typesToExclude, }) => {
    return (0, react_1.useMemo)(() => {
        const baseUrlsToExclude = typesToExclude.map((excludedType) => (0, graph_1.extractBaseUrl)(excludedType.$id));
        const filteredTypeOptions = new Map();
        for (const option of typeOptions) {
            const optionBaseUrl = (0, graph_1.extractBaseUrl)(option.$id);
            if (baseUrlsToExclude.includes(optionBaseUrl)) {
                continue;
            }
            const existingOption = filteredTypeOptions.get(optionBaseUrl);
            if (!existingOption ||
                (0, graph_1.extractVersion)(existingOption.$id) < (0, graph_1.extractVersion)(option.$id)) {
                filteredTypeOptions.set(optionBaseUrl, option);
            }
        }
        return Array.from(filteredTypeOptions.values());
    }, [typeOptions, typesToExclude]);
};
exports.useFilterTypeOptions = useFilterTypeOptions;
